import {
  BarChart3,
  BookOpen,
  Bot,
  Building,
  Building2,
  Download,
  GitBranch,
  Handshake,
  Inbox,
  LayoutDashboard,
  LayoutGrid,
  ListTodo,
  Link2,
  ListChecks,
  Mail,
  MessagesSquare,
  PanelTop,
  Radio,
  Rocket,
  Send,
  Settings,
  Sparkles,
  Tag,
  Upload,
  UserCog,
  Users,
  UsersRound,
  Wand2,
  Wallet,
  Workflow,
  Zap,
} from "lucide-react";
import { t } from "@/lib/i18n";

export type AppIcon = typeof Inbox;

export type AppItem = { type: string; label: string; hint: string; icon: AppIcon };
export type AppGroup = { title: string; items: AppItem[] };

/** Единый список разделов рабочего пространства: хаб, шапка и меню берут данные отсюда. */
export const APP_GROUPS: AppGroup[] = [
  {
    title: t("Рабочий экран"),
    items: [
      { type: "dashboard", label: t("Дашборд"), hint: t("Сводка и нагрузка"), icon: LayoutDashboard },
      { type: "inboxapp", label: t("Входящие"), hint: t("Диалоги и папки"), icon: Inbox },
      { type: "contactsapp", label: t("Контакты"), hint: t("База клиентов"), icon: Users },
      { type: "companies", label: t("Компании"), hint: t("Клиенты и их люди"), icon: Building },
      { type: "deals", label: t("Сделки"), hint: t("Воронка и канбан"), icon: Handshake },
      { type: "tasks", label: t("Задачи"), hint: t("Мои задачи и сроки"), icon: ListTodo },
      { type: "finance", label: t("Финансы"), hint: t("Дебиторка Books"), icon: Wallet },
      { type: "inbox", label: t("Диалоги"), hint: t("Живой чат"), icon: MessagesSquare },
    ],
  },
  {
    title: t("Каналы"),
    items: [
      { type: "channels", label: t("Каналы"), hint: t("Подключение номеров"), icon: Radio },
      { type: "catalog", label: t("Каталог"), hint: t("Провайдеры"), icon: LayoutGrid },
      { type: "email", label: t("Почта"), hint: t("Ящики и письма"), icon: Mail },
      { type: "widgets", label: t("Виджеты"), hint: t("Чат на сайте"), icon: PanelTop },
    ],
  },
  {
    title: t("Клиенты и данные"),
    items: [
      { type: "fields", label: t("Поля"), hint: t("Карточка клиента"), icon: ListChecks },
      { type: "lifecycle", label: t("Этапы"), hint: t("Воронка продаж"), icon: GitBranch },
      { type: "tags", label: t("Теги"), hint: t("Темы диалогов"), icon: Tag },
      { type: "contactsimport", label: t("Импорт"), hint: t("Контакты из CSV"), icon: Upload },
      { type: "dataexport", label: t("Экспорт"), hint: t("Выгрузка данных"), icon: Download },
      { type: "zoholink", label: "Zoho", hint: t("CRM и Books → Hub"), icon: Link2 },
    ],
  },
  {
    title: "AI",
    items: [
      { type: "aiassist", label: "AI Assist", hint: t("Подсказки ответов"), icon: Sparkles },
      { type: "aiagents", label: t("AI-агенты"), hint: t("Автоответы 24/7"), icon: Bot },
      { type: "knowledge", label: t("Знания"), hint: t("Источники AI"), icon: BookOpen },
      { type: "prompts", label: t("Промпты"), hint: t("Правила текста"), icon: Wand2 },
    ],
  },
  {
    title: t("Автоматизация"),
    items: [
      { type: "workflows", label: t("Процессы"), hint: t("Триггеры и шаги"), icon: Workflow },
      { type: "broadcasts", label: t("Рассылки"), hint: t("Массовые отправки"), icon: Send },
      { type: "snippets", label: t("Шаблоны"), hint: t("Быстрые ответы"), icon: Zap },
      { type: "conversations", label: t("Правила"), hint: t("Закрытие диалогов"), icon: MessagesSquare },
    ],
  },
  {
    title: t("Настройки и отчёты"),
    items: [
      { type: "settings", label: t("Настройки"), hint: t("Всё в одном окне"), icon: Settings },
      { type: "generalsettings", label: t("Общие"), hint: t("Название и время"), icon: Building2 },
      { type: "usersettings", label: t("Пользователи"), hint: t("Доступы"), icon: UserCog },
      { type: "teamsettings", label: t("Команды"), hint: t("Группы и роли"), icon: UsersRound },
      { type: "reports", label: t("Отчёты"), hint: t("Метрики и графики"), icon: BarChart3 },
      { type: "onboarding", label: t("Старт"), hint: t("Первые шаги"), icon: Rocket },
    ],
  },
];

export const APP_ITEMS: AppItem[] = APP_GROUPS.flatMap((g) => g.items);

export const APP_BY_TYPE: Record<string, AppItem> = Object.fromEntries(APP_ITEMS.map((i) => [i.type, i]));